import BaseModel from "./BaseModel";

class ReportModel extends BaseModel {
  reportYear = 0;

  constructor(options?: object) {
    super(options);
    this.setData(options);
  }
}

export default ReportModel;
